module.exports = __webpack_public_path__ + "static/media/taches.846c6de1.png";